export default __webpack_public_path__ + "static/media/arrow-white.fc310a69.svg";